export enum VARIANT {
  DECIMAL = 'DECIMAL',
  INTEGER = 'INTEGER',
  TIME = 'TIME',
}
